<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Experiments with Power</h1>
<h1 class="bk1">Obeah and the Remaking of Religion in Trinidad</h1>
<p class="bkau">J. Brent Crosson</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-crosson-0004.vue?7f18e623